/**
 * useForecastWorkbooks — the weekly workbook archive list (quick-260922-mvc).
 *
 * GET /api/forecast/workbooks, same SF-session gate as the forecast payload.
 * Kept in its own module (not useForecast.ts) so the page test's mock of that
 * module keeps working unchanged and this hook can be mocked on its own.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch, UnauthenticatedError } from '../lib/api-client.js';

import type { ForecastWorkbookArchiveList } from '@saledash/shared';

export function useForecastWorkbooks(enabled = true): UseQueryResult<ForecastWorkbookArchiveList> {
  return useQuery<ForecastWorkbookArchiveList>({
    queryKey: ['forecast', 'workbooks'],
    queryFn: ({ signal }) =>
      apiFetch<ForecastWorkbookArchiveList>('/api/forecast/workbooks', { signal, noLoginRedirect: true }),
    enabled,
    staleTime: 10 * 60_000,
    retry: (failureCount, error) => !(error instanceof UnauthenticatedError) && failureCount < 2,
  });
}
